import { Navigate, useRoutes } from 'react-router-dom';

import { lazy, Suspense } from 'react';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
// layouts
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
// config
import { PATH_AFTER_LOGIN } from '../config';
// pages
import {
  LoginPage,
  DashboardPage,
  SettingsPage,
  SkillsAgentsPage,
  SkillsGlobalPage,
  // SkillGroupEdit,
  SkillGroupPage,
  SkillsBlocksPage,
  InterfaceGlobalPage,
  InterfaceChatPage,
  InterfaceFormPage,
  ErrorPage,
} from './elements';

// const SkillsGroupView = lazy(() => import('../pages/skills/SkillsGroupView'));

// ----------------------------------------------------------------------

export default function Router() {

  return useRoutes([

    // Root = !authentifié ? Login Page : Main Pages
    {
      path: '/',
      element: (
        <GuestGuard>
          <LoginPage />
        </GuestGuard>
      )
    },

    // Login Page
    {
      path: 'auth',
      children: [
        {
          path: 'login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        }
      ],
    },

    // Dashboard Pages
    {
      path: 'main',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'analytics', element: <DashboardPage /> },

        {
          path: 'skills',
          children: [
            // { element: <Navigate to="/main/skills/groups" replace />, index: true },
            { element: <SkillsBlocksPage />, index: true },
            { path: 'global', element: <SkillsGlobalPage /> },
            { path: 'groups', element: <SkillsBlocksPage /> },
            { path: ':id', element: <SkillGroupPage /> },
            // { path: 'new', element: <SkillNew /> },
            // { path: ':id/edit', element: <SkillGroupEdit /> },
            { path: 'agents', element: <SkillsAgentsPage /> }
          ],
        },
        {
          path: 'interface',
          children: [
            { element: <Navigate to="/main/interface/global" replace />, index: true },
            { path: 'global', element: <InterfaceGlobalPage /> },
            { path: 'form', element: <InterfaceFormPage /> },
            { path: 'chat', element: <InterfaceChatPage /> }
          ],
        },
        {
          path: 'settings',
          children: [
            { element: <Navigate to="/main/settings/global" replace />, index: true },
            { path: 'global', element: <SettingsPage currentTabb={"global"} /> }
          ],
        },
      ],
    },

    // Error Page
    {
      element: <CompactLayout />,
      children: [
        { path: 'error', element: <ErrorPage /> }
      ],
    },
    { path: '*', element: <Navigate to="/error" replace /> }
    
  ]);
}
